import { Autocomplete, TextField } from "@mui/material";
import { styled } from "@mui/styles";
import { useField, useFormikContext } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IOption } from "../../interfaces/Utils";
import { isExists } from "../../utils";

interface IAutocompleteArray {
  name: string;
  options: IOption[];
  recordname?: string;
  label?: string;
  disableOptions?: IOption[];
  disabled?: boolean;
}

const CssTextField = styled(TextField)(({ theme }: any) => ({
  "& label.Mui-focused": {
    color: "#0063cc",
  },
  "& label.Mui-disabled": {
    color:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0063cc",
  },
  ".MuiOutlinedInput-input.Mui-disabled": {
    textFillColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e5e5e5",
    },
    "&.Mui-disabled": {
      color:
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.38)"
          : "rgba(0, 0, 0, 0.38)",
      fieldset: {
        borderColor:
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.38)"
            : "rgba(0, 0, 0, 0.38)",
      },
    },
    "&:hover fieldset": {
      borderColor: "#0063cc",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#0063cc",
    },
  },
}));

const AutocompleteArrayInput: FC<IAutocompleteArray> = ({
  name,
  options,
  label,
  recordname,
  disableOptions,
  disabled,
}) => {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  return (
    <Autocomplete
      multiple
      disabled={disabled}
      id="tags-outlined"
      onChange={(event, newValue) => {
        let value: any = [];

        newValue.forEach((item) => {
          if (recordname) {
            let obj: any = {};
            obj[recordname] = item.value;

            value.push(obj);
          } else {
            value.push(item.value);
          }
        });

        setFieldValue(field.name, value);
      }}
      getOptionDisabled={(option: IOption) => {
        const a =
          disableOptions
            ?.filter((disableOption: IOption) => isExists(disableOption?.value))
            .some(
              (disableOption: IOption) => disableOption.value === option.value
            ) || false;
        return a;
      }}
      options={options}
      value={
        isExists(field.value)
          ? options.filter((option) =>
              field.value
                .map((item: any) =>
                  recordname ? item[recordname as any] : item
                )
                .includes(option.value)
            )
          : []
      }
      renderInput={(params) => (
        <CssTextField {...params} label={label} error={Boolean(meta.error)} />
      )}
    />
  );
};

export default AutocompleteArrayInput;
